GP.GPMod('OneSignalGp',function(self){
    var _vent = null;
    var _util = null;
    var _log  = null;

    var _data = {
        // check and initialize a few params
        init: function() {
            _vent   = self.vent;
            _util = self.app.Util;
            _log   = self.app.Util.log;

            _data.reset();
        },
        reset: function() {
            _data.appid =  0;
            _data.config = null;
        },
        setAppConfig: function(appid, config){
            _data.appid = appid;
            _data.config = config;
        }, 
        appid: 0,
        config: null,
        pushEnabled: null,
        notificationPermission: null,
        optedOut: null,
        userSettings: null,
        promptRecord: null,
    };

    var _gui = {
        init: function() {
            // setup and jquery element binds
            // this.$error_msg = $('.alert-email-pref-error');
            // this.$success_msg = $('.alert-email-pref-success');
        }
    };

    var _apis = {
        // hookup ajax stuff here
        setuser_tags: function() {

            return OneSignal.sendTags({
                duid: GP.sdata.my_user.duid,
                gender: GP.sdata.my_user.gender,
                workflow: 'v3',
            });
        }, 
        update_user_settings: function(data) {
            return new Promise(function (resolve, reject){
                self.api
                .post('/app/members/onesignal/update',{
                    data: data,                  
                })
                .done(function(data){
                    resolve(data);
                })
                .fail(function(error){
                    reject(error);
                });
            });
        },
        register_user_app: function(data) {
            return new Promise(function (resolve, reject){
                self.api
                .post('/app/members/onesignal/register',{
                    data: data,                  
                })
                .done(function(data){
                    resolve(data);
                })
                .fail(function(error){
                    reject(error);
                });
            });
        },
        collect_state: function() {

            return Promise.all([
                OneSignal.isPushNotificationsEnabled(),
                OneSignal.getNotificationPermission(),
                OneSignal.isOptedOut(), 
                new Promise(function (resolve, reject){
                    self.api
                    .json('/app/members/onesignal/settings')
                    .done(function(data){
                        resolve(data);
                    })
                    .fail(function(error){
                        reject(error);
                    });
                })
            ])
            .then(function(results){
                //[isSubscribed, notificationPermission, optedOut, userSettings]
                _data.pushEnabled = results[0];
                _data.notificationPermission = results[1];
                _data.optedOut = results[2];
                _data.userSettings = results[3].settings;
                _util.info(_data.userSettings);
            })
            .catch(function(e) {
                console.error("Bad", e);
            });            
        }
    };

    var _events = {
        init: function() {

            if (window._gp_onesignal_config){
                _events.load_onesignal_sdk();
                _vent.on('init_js:user:home',_events.setup_initial);
            }

            _vent.on('OneSignalGp:state:dump',_events.dump_state);
            // add any other event bindings that other modules may need to call
        },
        setup_initial: function() {
            if (_events.check_ios_safari_standalone()) {
                OneSignal.showNativePrompt();
            } else {
                _events.soft_prompt_trigger();
            }
        },
        dump_state: function() {
            _util.info({
                appid: _data.appid,
                config: _data.config,
                notificationPermission: _data.notificationPermission,
                optedOut: _data.optedOut,
                pushEnabled: _data.pushEnabled,
                userSettings: _data.userSettings,
            });
        },
        load_onesignal_sdk: function(){

            $.getScript("https://cdn.onesignal.com/sdks/OneSignalSDK.js", function() {
                window.OneSignal = window.OneSignal || [];
                OneSignal.push(function() {
                    OneSignal.init(window._gp_onesignal_config.settings);
                    _events.setup_binds(window._gp_onesignal_config);
                });

            });
        },
        setup_binds: function(config) {
            _data.setAppConfig(config.appid, config.settings);

            OneSignal.getUserId().then(function(userId){
    
                if (userId) {
                   return  OneSignal.getTags();
                }
    
                return false;
    
            }).then(function(tags){                
                if (tags !== false && !tags.hasOwnProperty('duid')) {
                    //tags has not been set, set them up.
                    return _apis.setuser_tags();
                }
    
                return tags;
            }).then(function(tags){
    
                if (tags !== false) {
                    //different user on this device, mute notifications
                    return OneSignal.setSubscription(
                        (tags.duid == GP.sdata.my_user.duid)
                    );
                }
    
                return false;
            });

            OneSignal.on('subscriptionChange', _events.subscriptionChange);
            _apis.collect_state().then(function(){
                if(document.getElementById("onesignal-reload")){
                    _events.soft_prompt_trigger();
                }
            });
        },

        subscriptionChange: function(isSubscribed) {
            
            if (isSubscribed) {
                _apis.setuser_tags();
            }

            OneSignal.getNotificationPermission().then(function(permission){

                //change on permission
                if(permission != _data.notificationPermission) {
                    //callback to update notifications
                    _apis.update_user_settings({
                        permission: permission,
                        promptRecord: _data.promptRecord,
                    }).then(function(){

                        _data.promptRecord = null;
                        return _apis.collect_state();
                    }).then(function(){
                        if (isSubscribed) {
                            return OneSignal
                            .getUserId()
                            .then(function(userId){
                                return _apis.register_user_app({
                                    userId: userId,
                                    appId: _data.appid,
                                    ok: 1,
                                });
                            });
                        }
                    });             
                }
                //if permissions are the same, it means a different user logged into the same browser
                //we temporarly disabled notifications                
            });
        },
        soft_prompt_trigger: function() {
            //clear states that we should not show the soft prompt
            if(
                _data.pushEnabled || 
                _data.optedOut ||
                //the below case is for when we manually silence the notifications on this browser
                (!_data.pushEnabled && _data.notificationPermission == 'granted')
            ) {

                _util.info(
                    "Skipping SoftPrompt due to one of:",
                    "pushEnabled: ", _data.pushEnabled,
                    "Opted Out: ", _data.optedOut, 
                    "Other User: ", (!_data.pushEnabled && _data.notificationPermission == 'granted') 
                );
                return;
            }

            //we are in the middle of a softprompt workflow, don't show
            if (_data.promptRecord != null) {
                _util.info("Skipping SoftPrompt prompt submit in process");
                return;
            }

            //we haven't gather the state yet
            if (_data.optedOut == null) {
                _util.info("Skipping SoftPrompt haven't gather state yet");
                return;
            }

            //user disabled all notifications
            if (Array.isArray(_data.userSettings.notifications)) {
                _util.info("Skipping SoftPrompt user disabled all notifications");
                return;
            }

            //don't show soft-promts if less than 10min from registations
            var joinedMin = Math.floor((Date.now() - new Date(GP.sdata.my_user.join_date))/60000);
            if (joinedMin < 5) {
                _util.info("Skipping SoftPrompt user joined less than 10min ago");
                return;
            }

            _data.promptRecord = {
                date: Date.now(),
                softPromptAccepted: false,
            }; 

            var acceptedHandler = function(){
                //edge case where user takes a long time to accept or close the soft promtps
                if (!_data.promptRecord) {
                    _data.promptRecord = {
                        date: Date.now(),
                    };
                }
                _data.promptRecord.softPromptAccepted = true;
                OneSignal.showNativePrompt();
            };

            var cancelHandler = function(){

                if (!_data.promptRecord) {
                    _data.promptRecord = {
                        date: Date.now(),
                    };
                }
                _data.promptRecord.softPromptAccepted = false;

                _apis.update_user_settings({
                    permission: "denied",
                    promptRecord: _data.promptRecord,
                }).then(function(){
                    _data.promptRecord = null;
                    return _apis.collect_state();
                });

            };

            GP.vent.trigger('Modal:open:confirm', {
                template: 'ONESIGNAL',
                keyboard: false,
                backdrop: 'static',
            }, acceptedHandler, cancelHandler);
        },
        check_join_time: function() {
            // don't show if less than 5 min from registations
            var joinedMin = Math.floor((Date.now() - new Date(GP.sdata.my_user.join_date))/60000);
            if (joinedMin < 5) {
                return false;
            }
            return true;
        },
        check_ios_safari: function() {
            if (!_events.check_join_time()) {
                return false;
            }

            return (_util.check_ios() && _util.check_safari() && !window.navigator.standalone);
        },
        check_ios_safari_standalone: function() {
            if (!_events.check_join_time()) {
                return false;
            }

            return (_util.check_ios() && _util.check_safari() && window.navigator.standalone);
        }
    };


    this.addInitializer(function(){
        _data.init();
        _events.init();
    });
});